var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.44064 1.59333C4.59305 0.745735 3.18282 0.824113 2.56879 1.85358C1.7399 3.24327 1 4.96986 1 6.69806C1 8.85274 2.35629 10.2121 3.75797 11.6169C3.98213 11.8416 4.20747 12.0674 4.42858 12.2978C4.59299 12.4692 4.75598 12.6421 4.9187 12.8148C6.43138 14.4201 7.92009 16 10.3019 16C12.227 16 14.0155 15.4152 15.4995 14.4136C16.4031 13.8036 16.3825 12.5352 15.6116 11.7642L14.4226 10.5753C13.716 9.86866 12.5702 9.86866 11.8636 10.5753V10.5753C11.1569 11.282 10.0112 11.282 9.30454 10.5753L6.93049 8.20128C6.22383 7.49461 6.22383 6.34889 6.93049 5.64223V5.64223C7.63715 4.93556 7.63715 3.78984 6.93049 3.08318L5.44064 1.59333Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.ed21ef80b28b6e75c2c8ee8e5d2bce61.svg";
export { ForwardRef as ReactComponent };